import React from 'react';
import { cn } from '../utils';

export const Skeleton = ({ className, ...props }) => {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-gray-200", className)}
      {...props}
    />
  );
};

export const CardSkeleton = () => (
  <div className="bg-white rounded-[2rem] p-6 border border-gray-100 shadow-sm">
    <Skeleton className="w-16 h-16 rounded-2xl mb-4" />
    <Skeleton className="h-6 w-3/4 mb-2" />
    <Skeleton className="h-4 w-1/2 mb-4" />
    <div className="flex gap-2">
      <Skeleton className="h-8 w-20 rounded-xl" />
      <Skeleton className="h-8 w-20 rounded-xl" />
    </div>
  </div>
);

export const RoomCardSkeleton = () => (
  <div className="bg-white rounded-[2.5rem] p-8 border border-gray-100 shadow-sm">
    <div className="flex justify-between mb-6">
      <Skeleton className="w-14 h-14 rounded-2xl" />
      <Skeleton className="w-20 h-8 rounded-xl" />
    </div>
    <Skeleton className="h-7 w-full mb-3" />
    <Skeleton className="h-5 w-2/3 mb-6" />
    <div className="flex items-center gap-4 border-t border-gray-50 pt-6">
      <Skeleton className="w-10 h-10 rounded-full" />
      <Skeleton className="h-4 w-24" />
    </div>
  </div>
);
